import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import EcoImg from 'eco-design/base/eco-img';
import React from 'react';
import IconPlay from './comps/IconPlay';
import './index.scss';

export interface EcoVideoItemsItemProps extends ImgVideoProps {
    /**
     * logo 图标
     */
    logoIcon?: string;
    /**
     * 图片上悬浮的文案
     */
    imgTitle?: string;
    /**
     * 标题
     */
    title?: React.ReactNode;
    /**
     * 用户名称1
     */
    useName1?: React.ReactNode;
    /**
     * 用户名称2
     */
    useName2?: React.ReactNode;
    /**
     * 视频链接
     */
    videoSrc?: string;
}
interface EcoVideoItemsItemPropsIn extends EcoVideoItemsItemProps {
    /**
     * 对应的下标
     */
    index: number;
    /**
     * 点击回调
     */
    openItemHandle?: (item: EcoVideoItemsItemProps, index: number) => void;
}
/**
 * 多栏图片(标题 + 描述)
 */
export default function EcoVideoItemsCard({ openItemHandle, ...item }: EcoVideoItemsItemPropsIn) {
    const prefixCls = `eco-video-items`;
    return (
        <div className={`${prefixCls}-item`}>
            <div
                className={`${prefixCls}-item-img`}
                onClick={() => {
                    if (openItemHandle) {
                        openItemHandle(item, item.index);
                    }
                }}
            >
                <EcoImg pc={item.pc} />
                <div className={`${prefixCls}-item-img-title`}>{item.imgTitle}</div>
                <div className={`${prefixCls}-item-img-icon`}>{item.videoSrc && <IconPlay />}</div>
            </div>
            <div className={`${prefixCls}-item-msg`}>
                <EcoImg pc={item.logoIcon} className={`${prefixCls}-item-msg-l`} />
                <div className={`${prefixCls}-item-msg-r`}>
                    <div className={`${prefixCls}-item-msg-title`}>{item.title}</div>
                    <div className={`${prefixCls}-item-msg-useName1`}>{item.useName1}</div>
                    <div className={`${prefixCls}-item-msg-useName2`}>{item.useName2}</div>
                </div>
            </div>
        </div>
    );
}
